import { c as _c } from "react/compiler-runtime";
import { getChannel } from "@website/utils/channel/get-channel";
import { logoSchema } from "@website/widget/header/logo/schema";
export function Logo(t0) {
  const $ = _c(8);
  const {
    minimalLogo,
    disableURL: t1
  } = t0;
  const disableURL = t1 === undefined ? false : t1;
  const {
    label,
    image,
    title
  } = minimalLogo ? logoSchema.minimal : logoSchema[getChannel() as keyof typeof logoSchema] || logoSchema.default;
  const t2 = disableURL ? undefined : "/";
  const t3 = `${label} logo`;
  const t4 = (image as unknown as {
    src: string;
  }).src as string;
  let t5;
  if ($[0] !== t3 || $[1] !== t4 || $[2] !== title) {
    t5 = <img alt={t3} className="h-8 w-auto lg:h-10" height={78} loading="lazy" fetchPriority="high" src={t4} title={title} width={137} />;
    $[0] = t3;
    $[1] = t4;
    $[2] = title;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== label || $[5] !== t2 || $[6] !== t5) {
    t6 = <a aria-label={label} href={t2}>{t5}</a>;
    $[4] = label;
    $[5] = t2;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}